import { render, staticRenderFns } from "./ResultadosPorSemana.vue?vue&type=template&id=6094fdef&"
import script from "./ResultadosPorSemana.vue?vue&type=script&lang=js&"
export * from "./ResultadosPorSemana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports